export default Object.freeze({
  firebase: {
    apiKey: 'AIzaSyCbILzcsvVqBMtR6TZu1UklN37bUBCXLco',
    appId: '1:365362814788:web:d417dee3d49c9109220111',
    databaseURL: 'https://e-consequences-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'e-consequences'
  }
})
